// ============================================================================
// JARVISTRAVEL - ONBOARDING ON CORE (JAR-1870)
// Whether a person has finished onboarding, kept per account on core, so a
// browser that never saw them finish, or an account with no trips left, doesn't
// send a returning traveller through it again.
//
// Needs core's /v1/preferences/onboarding (core#941). On a core without it the
// read throws, so the gate answers "unknown" and stands down; it does not fall
// back to counting trips, which would send an onboarded account with no trips
// back through onboarding, the case this exists to stop.
// ============================================================================

import { api } from './client';

/** Whether core records the signed-in person as onboarded. Throws when core
 *  can't be read, so a caller can tell "not yet" from "unknown". */
export async function readOnboardedOnCore(): Promise<boolean> {
  const result = await api.get<{ onboarded: boolean }>('/preferences/onboarding');
  if (result.error) throw new Error(result.error.message || 'Failed to read onboarding');
  return result.data?.onboarded === true;
}

/** Records on core that `owner`, the Clerk user the app saw finish, has
 *  finished onboarding. Saying it again changes nothing. The token goes out
 *  with the request, so after an account switch it can be another account's:
 *  core then records nothing and answers 409 ACCOUNT_CHANGED (JAR-1974), and
 *  that throws like any other failure. */
export async function recordOnboardedOnCore(owner: string): Promise<void> {
  const result = await api.put('/preferences/onboarding', { clerk_user_id: owner });
  if (result.error) throw new Error(result.error.message || 'Failed to record onboarding');
}
